import { render, staticRenderFns } from "./TokenSecurityTaxCard.vue?vue&type=template&id=3475c124&scoped=true&"
import script from "./TokenSecurityTaxCard.vue?vue&type=script&lang=js&"
export * from "./TokenSecurityTaxCard.vue?vue&type=script&lang=js&"
import style0 from "./TokenSecurityTaxCard.vue?vue&type=style&index=0&id=3475c124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475c124",
  null
  
)

export default component.exports